import * as React from "react";
import { IPerformanceNumber } from "../../../types/usageTypes/IPerformanceNumber";
import { IUsageRowData } from "../../../types/usageTypes/IUsageRowData";

export interface IPerformanceNumbersSectionProps {
    usage: IUsageRowData;
    usageNumberInSearchExclude?: string[];
}

interface IPerformanceNumbersSectionState {
}

export class PerformanceNumbersSection extends React.PureComponent<
    IPerformanceNumbersSectionProps,
    IPerformanceNumbersSectionState
> {

    constructor(props: IPerformanceNumbersSectionProps) {
        super(props);
        this.state = {
        };
    }

    renderHorizontalRows() {
        const {
            usage,
            usageNumberInSearchExclude = []
        } = this.props

        const rows: JSX.Element[] = [];

        (usage.performanceNumbers || []).forEach((pn: IPerformanceNumber, index: number) => {
            const typeCode = (pn.typeCode || "").trim();
            const number = (pn.number || "").trim();

            if (!number) {
                return;
            }

            if (!usageNumberInSearchExclude.includes(typeCode.toUpperCase())) {
                rows.push(
                    <div key={index} className="horizontalRow col-md-3">
                        {typeCode && <label className="section col-md-12">{typeCode}:</label>}
                        {number && <p className="section col-md-12">{number}</p>}
                    </div>
                );
            }
        });

        return rows;
    }

    render() {
        const {

        } = this.props;
        const horizontalRows = this.renderHorizontalRows();

        return (
            <div className="performanceNumbers col-md-12" id={`performance-numbers-section`}>
                <div className="container">
                <h3>Performance Numbers</h3>
                    {horizontalRows}
                </div>
            </div>
        );

    }
}